
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/product",
      function () {
        return require("private-next-pages/gifts/product.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/product"])
      });
    }
  